import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Badge, {BadgeColor} from 'ui-library/Badge';

import type {ModelRunStatus} from './ModelRunTypes';

const STATUS_BADGE_CONFIG: Record<ModelRunStatus, {color: BadgeColor; label: string}> = {
  PENDING: {color: BadgeColor.GRAY, label: 'Pending'},
  RUNNING: {color: BadgeColor.YELLOW, label: 'Running'},
  SUCCEEDED: {color: BadgeColor.GREEN_FILLED, label: 'Succeeded'},
  FAILED: {color: BadgeColor.RED, label: 'Failed'},
};

interface ModelRunStatusBadgeProps {
  status: ModelRunStatus;
}

export default function ModelRunStatusBadge({status}: ModelRunStatusBadgeProps): JSX.Element {
  const config = STATUS_BADGE_CONFIG[status];
  return (
    <div
      aria-label={`Status: ${config.label}`}
      {...getTestProps({component: 'ModelRunStatusBadge', element: 'root'})}
    >
      <Badge color={config.color}>{config.label}</Badge>
    </div>
  );
}
